export default {
  'menu.workbench': '歡迎',
  'menu.platform-knowledge-graph.dashboard': '工作台',
  'menu.platform-knowledge-graph.ontology': '本體管理',
  'menu.platform-knowledge-graph.ontology.entity-types': '實體類型管理',
  'menu.platform-knowledge-graph.ontology.relation-types': '關係類型管理',
  'menu.platform-knowledge-graph.ontology.schema-view': '本體結構視圖',
  'menu.platform-knowledge-graph.entities': '平台實體庫',
  'menu.platform-knowledge-graph.entities.list': '全部實體',
  'menu.platform-knowledge-graph.entities.companies': '企業實體庫',
  'menu.platform-knowledge-graph.entities.persons': '人物實體庫',
  'menu.platform-knowledge-graph.entities.products': '產品實體庫',
  'menu.platform-knowledge-graph.entities.policies': '政策實體庫',
  'menu.platform-knowledge-graph.entities.industries': '行業實體庫',
  'menu.platform-knowledge-graph.entities.technologies': '技術實體庫',
  'menu.platform-knowledge-graph.entities.brands': '品牌實體庫',
  'menu.platform-knowledge-graph.entities.regions': '區域實體庫',
  'menu.platform-knowledge-graph.entities.organizations': '組織實體庫',
  'menu.platform-knowledge-graph.entities.standards': '標準實體庫',
  'menu.platform-knowledge-graph.entities.regulations': '法規實體庫',
  'menu.platform-knowledge-graph.entities.events': '事件實體庫',
  'menu.platform-knowledge-graph.entities.websites': '網站實體庫',
  'menu.platform-knowledge-graph.entities.web-pages': '網頁實體庫',
  'menu.platform-knowledge-graph.entities.articles': '文章實體庫',
  'menu.platform-knowledge-graph.entities.tags': '標籤實體庫',
  'menu.platform-knowledge-graph.entities.concepts': '概念實體庫',
  'menu.platform-knowledge-graph.relations': '平台關係庫',
  'menu.platform-knowledge-graph.graph': '圖譜可視化',
  'menu.platform-knowledge-graph.governance': '數據治理',
  'menu.platform-knowledge-graph.governance.deduplication': '實體去重',
  'menu.platform-knowledge-graph.governance.mapping': '實體映射',
  'menu.platform-knowledge-graph.governance.merge-logs': '合併記錄',
  'menu.platform-knowledge-graph.import': '數據導入',
  'menu.platform-knowledge-graph.import.data-sources': '數據源管理',
  'menu.platform-knowledge-graph.import.tasks': '導入任務',
  'menu.platform-knowledge-graph.open-settings': '開放設置',
  'menu.platform-knowledge-graph.settings': '系統設置',
  'menu.more-blocks': '更多區塊',
  'menu.home': '首頁',
  'menu.admin': '权限',
  'menu.admin.sub-page': '二级管理页',
  'menu.settings': '設置',
  'menu.login': '登錄',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析頁',
  'menu.dashboard.monitor': '監控頁',
  'menu.dashboard.workplace': '工作臺',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表單頁',
  'menu.form.basic-form': '基礎表單',
  'menu.form.step-form': '分步表單',
  'menu.form.step-form.info': '分步表單（填寫轉賬信息）',
  'menu.form.step-form.confirm': '分步表單（確認轉賬信息）',
  'menu.form.step-form.result': '分步表單（完成）',
  'menu.form.advanced-form': '高級表單',
  'menu.list': '列表頁',
  'menu.list.table-list': '查詢表格',
  'menu.list.basic-list': '標淮列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（項目）',
  'menu.list.search-list.applications': '搜索列表（應用）',
  'menu.profile': '詳情頁',
  'menu.profile.basic': '基礎詳情頁',
  'menu.profile.advanced': '高級詳情頁',
  'menu.result': '結果頁',
  'menu.result.success': '成功頁',
  'menu.result.fail': '失敗頁',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '個人頁',
  'menu.account.center': '個人中心',
  'menu.account.workbench': '返回工作臺',
  'menu.account.tenantManagement': '企業管理',
  'menu.account.trigger': '觸發報錯',
  'menu.account.logout': '退出登錄',
  'menu.editor': '圖形編輯器',
  'menu.editor.flow': '流程編輯器',
  'menu.editor.mind': '腦圖編輯器',
  'menu.editor.koni': '拓撲編輯器',
};
